import React  from "react";
import {useEffect,useState }  from "react";
import AxiosInstance from '../../../services/AxiosInstance';
import {RESOLVER_URL, RESOLVER_GROUP_URL, USERS_URL} from '../../../Constants/Constants';
import Container from 'react-bootstrap/Container';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
//import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

function Resolver(){  

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));

      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));

  const [data, setData] = useState([]);    

  useEffect(() => {
    getResolver();
    getResolverGroups();
    getUsers();
  }, []);
   
  const [rgData, setRGData] = useState([]); 
  const [rgId, setRGId] = useState([]); 

  const [userData, setUserData] = useState([]); 
  const [userId, setUserId] = useState([]); 


  const [resolverId, setResolverId] = useState("-1");
  const [resolverName, setResolverName] = useState("");
  const [resolvers, setResolvers] = useState([]);
  
  const getResolverGroups = () => {
    AxiosInstance.get(RESOLVER_GROUP_URL).then(response => setRGData(response.data.data));      
  }

  const getResolver = () => {
    AxiosInstance.get(RESOLVER_URL).then(response => setData(response.data));      
  }

  const getUsers = () => {
    AxiosInstance.get(USERS_URL).then(response => setUserData(response.data.data));      
  }

  const saveResolver = ()=>{
    AxiosInstance.post(RESOLVER_URL, {user:{id:userId}, resolverGroup:{id:rgId}})
    .then((response) => {alert("Resolver created successfully!");getResolver();})
    .catch((error)=>{
      alert("Resolver creation failed!")
      console.error(error)
    });
  }

    const [page, setPage] = React.useState(0);    
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    
  
    const visibleRows = React.useMemo(
        () =>
          [...data]            
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [data, page, rowsPerPage],
      );

      const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRGChange = (event) =>{
    setRGId(event.target.value);
  }

  const handleUserChange = (event) =>{
    setUserId(event.target.value);
  }

  return (
    <Container fluid>      
      <fieldset >
        <legend>Resolver</legend>
        <React.Fragment>
            <Button variant="outlined" onClick={handleClickOpen} style={{float:"right", margin:"5px"}}>
              Add Resolver Group
            </Button>
              <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                  component: 'form',
                  onSubmit: (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries((formData).entries());
                    const name = formJson.name;
                    console.log(name);
                    saveResolver();                    
                    handleClose();
                  },
                }}
              >
                <DialogTitle>Add Resolver</DialogTitle>
                <DialogContent>
                  {/* <DialogContentText>
                    To subscribe to this website, please enter your email address here. We
                    will send updates occasionally.
                  </DialogContentText> */}
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }}>
                      <InputLabel id="demo-simple-select-standard-label">Resolver Group</InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={rgId}
                        onChange={handleRGChange}
                        label="Resolver Group"
                      >

                         <MenuItem value=""> <em>None </em> </MenuItem> 
                        {rgData.map((rg) => <MenuItem value={rg.id}>{rg.name}</MenuItem>)}
                       
                        
                      </Select>
                    </FormControl>
                      <br/>
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }}>
                      <InputLabel id="resolver-id">Resolver</InputLabel>
                      <Select
                        labelId="resolver-id"
                        id="select-resolver-id"
                        value={userId}
                        onChange={handleUserChange}
                        label="Resolver"
                      >

                         <MenuItem value=""> <em>None </em> </MenuItem> 
                        {userData.map((user) => <MenuItem value={user.id}>{user.name}</MenuItem>)}
                       
                        
                      </Select>
                    </FormControl>

                  
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button type="submit">Add </Button>
                </DialogActions>
              </Dialog>
            </React.Fragment>

            {/* <Link to={`/signup`} style={{float:"right", marginRight:"5px"}}>Add Resolver</Link> */}
            <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                                <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                    <TableRow>
                        <StyledTableCell>Resolver ID</StyledTableCell>
                        <StyledTableCell>Resolver</StyledTableCell>
                        <StyledTableCell>Resolver Group ID</StyledTableCell>
                        
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {visibleRows.map((resolver, index) => {                
                            return (                    
                                    <StyledTableRow>
                                    <StyledTableCell>{resolver.id}</StyledTableCell>
                                    <StyledTableCell>{resolver.resolverGroup.name}</StyledTableCell>
                                    <StyledTableCell>{resolver.user.id}</StyledTableCell>
                                    
                                    </StyledTableRow>
                                    )
                                })}        
                
                    
                    </TableBody>
                </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                    </Paper>
                    </Box>
                </fieldset>
            </Container>
        )
}
//https://mui.com/material-ui/react-table/#custom-pagination-actions
export default Resolver;